var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-view',{staticClass:"accountList"},[_c('tab-components-vue',{on:{"tabNumChange":_vm.tabNumChange}}),(_vm.currentNum == 0)?_c('Sortingcenter'):_vm._e(),(_vm.currentNum == 1)?_c('Residentcenter'):_vm._e(),(_vm.currentNum == 2)?_c('Toxiccenter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }